import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { FaTasks, FaChartBar } from 'react-icons/fa';
import { AuthContext } from '../../context/AuthContext';
import '../../components/common/DashboardQuickLinks.css';

// Only two real top-level destinations exist for an examiner - job-specific
// detail/upload pages need a job id and are reached *from* the jobs list,
// not directly linkable from here.
const QUICK_LINKS = [
  { title: 'My Jobs', text: 'View your assigned jobs and their progress.', path: '/examiner/jobs', icon: <FaTasks /> },
  { title: 'My Reports', text: 'Access your exam performance reports.', path: '/examiner/reports', icon: <FaChartBar /> }
];

function ExaminerDashboard() {
  const { user } = useContext(AuthContext);

  return (
    <Container fluid className="examiner-dashboard py-5" style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
      <Row className="justify-content-center mb-5">
        <Col lg={8} md={10} sm={12} className="text-center">
          <h1 className="display-4 mb-3">Welcome, {user?.fullName || 'Examiner'}!</h1>
        </Col>
      </Row>
      <Row className="justify-content-center">
        {QUICK_LINKS.map((link) => (
          <Col md={4} sm={6} className="mb-4" key={link.path}>
            <Link to={link.path} className="text-decoration-none">
              <Card className="shadow-sm border-0 h-100 dashboard-quick-link">
                <Card.Body className="text-center">
                  <div className="h3 text-primary mb-2">{link.icon}</div>
                  <Card.Title className="h5 text-dark">{link.title}</Card.Title>
                  <Card.Text className="text-muted">{link.text}</Card.Text>
                </Card.Body>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default ExaminerDashboard;
